var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "section1" }, [
      _c("div", { staticClass: "header-logo" }, [
        _c(
          "a",
          {
            staticClass: "flex-align-center",
            attrs: {
              href: "https://marginx.io",
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          [
            _c("i", { staticClass: "icon icon-inviteActivity-marginx-logo" }),
            _c("i", { staticClass: "icon icon-inviteActivity-logo-font" }),
          ]
        ),
      ]),
      _c("div", { staticClass: "bg" }, [
        _c("div", { staticClass: "bg-img" }, [
          _c("img", {
            attrs: {
              src: require("@/assets/images/inviteActivity/m-header.svg"),
              alt: "",
            },
          }),
        ]),
      ]),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "section1-text" }, [
          _c("h3", [_vm._v("Join MarginX and get airdrop your")]),
          _c("h3", { staticClass: "text-MarginX" }, [
            _vm._v("very own starter NFT!"),
          ]),
          _c("h4", [
            _vm._v(
              " This entitles you to 5% trading rebates and 5% referral commissions... for a lifetime! "
            ),
          ]),
        ]),
        _c("div", { staticClass: "section1-text-p" }, [
          _c("strong", [
            _vm._v(
              " This process is not currently supported on mobile. Please open this referral link in your desktop browser for a smoother experience. "
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }